import "core-js/modules/es.array.sort.js";
export var NEXT_ORDER_TYPES = {
  none: 'desc',
  desc: 'asc',
  asc: 'desc'
};
export var orderByIndex = function orderByIndex(originalArray, index, orderType, ordering) {
  if (orderType === 'asc' && ordering === 'child' && index !== -1) {
    originalArray.sort(function (a, b) {
      return a.cells[index]._orderableValue > b.cells[index]._orderableValue ? 1 : a.cells[index]._orderableValue < b.cells[index]._orderableValue ? -1 : 0;
    });
  }
  if (orderType === 'desc' && ordering === 'child' && index !== -1) {
    originalArray.sort(function (a, b) {
      return a.cells[index]._orderableValue < b.cells[index]._orderableValue ? 1 : a.cells[index]._orderableValue > b.cells[index]._orderableValue ? -1 : 0;
    });
  }
};